import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import {
    ITCIMarketplaceListing,
    ITCITenantComponentOptions,
    ITCIMarketplaceV2RatingResponse,
    ITCIRatingComment,
    TCI_MARKETPLACE_LISTING_MENU_TYPE,
    SERVICE_URLS
} from "@tci/common";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";
import { Observable } from "rxjs/Observable";

@Injectable()
export class NgMarketplaceV2ListingService {
    private static instance: NgMarketplaceV2ListingService = null;

    private selectedAsset: ITCIMarketplaceListing;

    static getInstance(userSvc: NgUserService, http: Http) {
        if (!NgMarketplaceV2ListingService.instance) {
            NgMarketplaceV2ListingService.instance = new NgMarketplaceV2ListingService(userSvc, http);
        }
        return NgMarketplaceV2ListingService.instance;
    }

    constructor(private userSvc: NgUserService, private http: Http) {
    }

    setSelectedAsset(asset: ITCIMarketplaceListing): void {
        this.selectedAsset = asset;
    }

    getRatings(asset: ITCIMarketplaceListing): Observable<ITCIMarketplaceV2RatingResponse> {
        return this.http.get(`${SERVICE_URLS.MARKETPLACE}/${asset.id}/rating`)
            .catch(e => {
                const errStr = "Could not get ratings data for " + asset.id;
                console.error(errStr, e);
                const errRes: ITCIMarketplaceV2RatingResponse = {
                    data: null,
                    success: false,
                    error: { message: errStr, statusMessage: errStr }
                };
                return Observable.of(errRes as any);
            })
            .map(res => {
                let ratings: ITCIMarketplaceV2RatingResponse;
                try {
                    ratings = res.json();
                } catch (e) {
                    ratings = res; // Bind error
                }

                return ratings;
            });
    }

    postRatings(asset: ITCIMarketplaceListing, rating: ITCIRatingComment, toUpdate: boolean): Observable<ITCIMarketplaceV2RatingResponse> {
        let method: Observable<Response>;
        if (toUpdate) {
            method = this.http.put(`${SERVICE_URLS.MARKETPLACE}/${asset.id}/rating`, rating);
        } else {
            method = this.http.post(`${SERVICE_URLS.MARKETPLACE}/${asset.id}/rating`, rating);
        }

        return method
            .catch(e => {
                const errStr = "Could not post ratings data for " + asset.id;
                console.error(errStr, e);
                const errRes: ITCIMarketplaceV2RatingResponse = {
                    data: null,
                    success: false,
                    error: { message: errStr, statusMessage: errStr }
                };
                return Observable.of(errRes as any);
            })
            .map(res => {
                let ratings: ITCIMarketplaceV2RatingResponse;
                try {
                    ratings = res.json();
                } catch (e) {
                    ratings = res; // Bind error
                }

                return ratings;
            });
    }
}
